import { DimensionModel } from '@core/model/dimension.model';
import { LuzCapaInfo } from './LuzCapaInfo.model';
import { ModelInfo } from './modelInfo.model';
import { CerradurasAdicionalesModel } from './cerradurasAdicionales.model';
import { lock } from './lock.model';

interface AccList {
    ItemId: string,
    ItemName: string,
    Type: number
 }

 interface ProcessList {
    Process: string,
    UrlImage: string
    OnlyQuotProcess: boolean;
 }

export class PrefaSinReglasInfo extends ModelInfo {
    vListaConfig: DimensionModel[];
    vListaAcabados: DimensionModel[];
    vListaProcesos: ProcessList[];
    vListaAccesorios: AccList[];
    vListaAccSinHalad: AccList[];
    vListaLuzCapa: LuzCapaInfo[];
    vListaCedazos: LuzCapaInfo[];
    vConfiguracion: string;
    vAlias: string;
    vListaCerraduras: lock[];
    vListaCerradurasAdicionales: CerradurasAdicionalesModel[];
    vProceso: string;
    vAcabado: string;
    vTamano: string;
    vCerradura: string;
    vCerraduraReq: boolean;
    vManipulaCerradura: string;
    vContramarco: boolean;
    vTipoContramarco: string;
    vGuarnicion: boolean;
    vTipoGuarnicion: string;
    vRampa: number;
    vRodines: string;
    vCedazo: string;
    vBoolCedazo: boolean;
    vPosicionCedazo: string;
    vSeguroCorredizo: boolean;
    vCantVias: number;
    vBarraRefuerzo: boolean;
    vPerfilCedazo: string;
    vPerfilReforzado: boolean;
    vEnvidriador: string;
    vPerfilVertical: boolean;

    //PabLujo
    vAlturaDivision: number;
    vApertura: string;
    vCantDivisiones: number;
    vCerraduraOpcional1: string;
    vCerraduraOpcional2: string;
    vPosCerradura: string;

    vAccion: string;
    vBarraEmpuje: string;
    vBarraExtra: string;
    vCantInfExtra: number;
    vDivisiones: string;
    vHaladeraConcha: string;
    vInferiorExtra: string;
    vLlave: string;
    vTipoEnvidriador: string;
    vTipoMedidas: string;
    vUmbral: string;

    //Automatismo
    vAutomatismoCod: string;
    vAutomatismoReq: boolean;

    // vDrenaje: boolean;
    // vPuntas: boolean;
    // vHuecos: boolean;

    constructor() {
    super();
    this.vListaConfig = [];
    this.vListaLuzCapa = [];
    this.vListaCedazos = [];
    this.vListaProcesos = [];
    this.vListaAccesorios = [];
    this.vListaAccSinHalad = [];
    this.vConfiguracion = '';
    this.vAlias = '';
    this.vListaCerraduras = [];
    this.vListaCerradurasAdicionales = [];
    this.vProceso = '';
    this.vAcabado = '';
    this.vTamano = '';
    this.vCerradura = '';
    this.vCerraduraReq = true;
    this.vManipulaCerradura = '';
    this.vContramarco = true;
    this.vTipoContramarco = '';
    this.vGuarnicion = false;
    this.vTipoGuarnicion = '';
    this.vRampa = 1;
    this.vRodines = '';
    this.vCedazo = '';
    this.vBoolCedazo = true;
    this.vPosicionCedazo = '';
    this.vSeguroCorredizo = false;
    this.vCantVias = 3;
    this.vBarraRefuerzo = false;
    this.vPerfilCedazo = '';
    this.vPerfilReforzado = true;
    this.vEnvidriador = '';
    this.vPerfilVertical = false;
    this.vAlturaDivision = 0;
    this.vApertura = '';
    this.vCantDivisiones = 0;
    this.vCerraduraOpcional1 = '';
    this.vCerraduraOpcional2 = '';
    this.vPosCerradura = '';
    this.vUmbral = '';
    this.vAccion = '';
    this.vBarraEmpuje = '';
    this.vBarraExtra = '';
    this.vInferiorExtra = '';
    this.vDivisiones = '';
    this.vCantInfExtra = 0;
    this.vLlave = '';
    this.vTipoEnvidriador = '';
    this.vTipoMedidas = '';
    this.vHaladeraConcha = '';
    this.vAutomatismoCod = '';
    this.vAutomatismoReq = false;
    // this.vDrenaje = false;
    // this.vPuntas = false;
    // this.vHuecos = false;
    }

}
